export default __webpack_public_path__ + "images/CodingIcon.1b8198f69259a9e56b474ea8dc7f9079.png";